import React from 'react';

import { useSelector } from 'react-redux';

import { ReactionType } from '../../../../../../types';
import { selectHasNonSelfParticipantRaisedHand } from '../../../../selectors';
import { ToolbarOption } from '../../toolbar-option';
import { useReactionProps } from './use-reaction-props';

type Props = {
    reactionType: ReactionType;
};

export function ReactionOption({ reactionType }: Props) {
    const { onClick, iconName, title } = useReactionProps(reactionType);
    const hasRaisedhands = useSelector(selectHasNonSelfParticipantRaisedHand);
    const dotColor = hasRaisedhands ? 'green' : undefined;

    return <ToolbarOption iconName={iconName} onClick={onClick} title={title} content={title} dotColor={dotColor} />;
}
